import { createRequestAtom } from '../../../../shared/utils/request-atom';
import { SubscribedPlan } from '../typings';

export const subscribedPlanAtom = createRequestAtom<SubscribedPlan>({
  initialLoading: false,
});
